var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 0c5.52285 0 10 4.47715 10 10s-4.47715 10-10 10S0 15.52285 0 10 4.47715 0 10 0zm4.91385 5.08615c-.09845-.09846-.24933-.11252-.36276-.0422l-.05318.0422L10 9.58412 5.50209 5.08615l-.04073-.03404c-.11463-.0794-.27312-.06806-.37521.03404-.09846.09845-.11252.24933-.0422.36276l.0422.05318L9.58412 10l-4.49797 4.49791-.03404.04073c-.0794.11463-.06806.27312.03404.37521.09845.09846.24933.11252.36276.0422l.05318-.0422L10 10.41588l4.49791 4.49797.04073.03404c.11463.0794.27312.06806.37521-.03404.09846-.09845.11252-.24933.0422-.36276l-.0422-.05318L10.41588 10l4.49797-4.49791.03404-.04073c.0794-.11463.06806-.27312-.03404-.37521z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXFilled);
export default __webpack_public_path__ + "static/media/x-filled.c82f4933.svg";
export { ForwardRef as ReactComponent };